import React from "react";

const games = [
  {
    id: "smash-karts",
    title: "Smash Karts",
    description: "Multiplayer kart battle game with powerups and mayhem.",
    genre: "Racing / Multiplayer",
    externalUrl: "https://www.crazygames.com/game/smash-karts",
  },
  {
    id: "drift-hunters",
    title: "Drift Hunters",
    description: "Tune your car and drift through city streets and tracks.",
    genre: "Racing / Simulation",
    externalUrl: "https://www.crazygames.com/game/drift-hunters",
  },
  {
    id: "crazy-roll-3d",
    title: "Crazy Roll 3D",
    description: "Endless 3D ball-rolling runner game in a neon world.",
    genre: "Arcade / Runner",
    externalUrl: "https://www.crazygames.com/game/crazy-roll-3d",
  },
  {
    id: "bullet-force-multiplayer",
    title: "Bullet Force",
    description: "Fast-paced modern multiplayer FPS with multiple modes.",
    genre: "Shooter / Multiplayer",
    externalUrl: "https://www.crazygames.com/game/bullet-force-multiplayer",
  },
  {
    id: "paper-io-2",
    title: "Paper.io 2",
    description: "Expand your territory while avoiding enemies.",
    genre: "Arcade / IO",
    externalUrl: "https://www.crazygames.com/game/paper-io-2",
  },
  {
    id: "idle-mining-empire",
    title: "Idle Mining Empire",
    description: "Automate your mining empire and build your fortune.",
    genre: "Idle / Strategy",
    externalUrl: "https://www.crazygames.com/game/idle-mining-empire",
  },
  {
    id: "minibattles",
    title: "12 MiniBattles",
    description: "Compete in fun and quirky 2-player mini games.",
    genre: "Multiplayer / Party",
    externalUrl: "https://www.crazygames.com/game/12-minibattles",
  },
  {
    id: "archery-world-tour",
    title: "Archery World Tour",
    description: "Test your aim and precision in this archery challenge.",
    genre: "Sports / Skill",
    externalUrl: "https://www.crazygames.com/game/archery-world-tour",
  },
  {
    id: "moto-x3m",
    title: "Moto X3M",
    description: "Speed through challenging bike stunts and obstacles.",
    genre: "Racing / Stunt",
    externalUrl: "https://www.crazygames.com/game/moto-x3m",
  },
  {
    id: "foot-chinko",
    title: "Foot Chinko",
    description: "Soccer meets pinball in this arcade football game.",
    genre: "Sports / Soccer",
    externalUrl: "https://www.crazygames.com/game/foot-chinko",
  },
  // 🧒 Gwenny’s Picks
    {
    id: "count-masters",
    title: "Count Masters: Stickman Games",
    description: "Lead your stickman army, count to grow, and conquer the crowd!",
    genre: "Arcade / Action",
    externalUrl: "https://www.crazygames.com/game/count-masters-stickman-games",
  },
  {
    id: "wendy-soft-girl-makeup",
    title: "Wendy Soft Girl Makeup",
    description: "Help Wendy get a fresh and fun soft girl look with makeup and style!",
    genre: "Makeup / Fashion",
    externalUrl: "https://www.crazygames.com/game/wendy-soft-girl-makeup",
  },
  {
    id: "paper-doll-diary",
    title: "Paper Doll Diary: Dress Up DIY",
    description: "Customize your paper doll diary with outfits, stickers, and creativity.",
    genre: "DIY / Dress-Up",
    externalUrl: "https://www.crazygames.com/game/paper-doll-diary-dress-up-diy",
  },
  {
    id: "paper-princess",
    title: "Paper Princess: Doll Dress Up",
    description: "Style your own princess with beautiful paper outfits and accessories.",
    genre: "Princess / Dress-Up",
    externalUrl: "https://www.crazygames.com/game/paper-princess---doll-dress-up",
  },
  {
    id: "kitty-cats",
    title: "Kitty Cats",
    description: "Take care of your own adorable kitty cats in this cute pet sim!",
    genre: "Pet / Cute",
    externalUrl: "https://www.crazygames.com/game/kitty-cats",
  },
];

const Home = () => {
  return (
    <div className="home">
      <h1>Welcome to Unfamiliar Gaming</h1>
      <p>Choose a game to play or see the leaderboard.</p>

      <h2>🎮 Available Games</h2>
      <ul className="game-list">
        {games.map((game) => (
          <li key={game.id} className="game-card">
            <h3>{game.title}</h3>
            <p>{game.description}</p>
            <p><strong>Genre:</strong> {game.genre}</p>
            <a href={game.externalUrl} target="_blank" rel="noopener noreferrer">
              <button className="btn btn-primary">🚀 Start Game</button>
            </a>
          </li>
        ))}
      </ul>

      <div className="leaderboard-link">
        <h2>🏆 Leaderboard</h2>
        <p>Leaderboards will be available in a future update.</p>
      </div>
    </div>
  );
};

export default Home;